import { atom } from "jotai";
import { observe } from "jotai-effect";

import { currentUserIdAtom } from "@/atoms/session";
import Bugsnag from "@/utils/bugsnag";
import { supabase } from "@/utils/supabase";

export const profileNameAtom = atom<null | string>(null);

export const updateProfileNameAtom = atom(
  null,
  (_get, set, { name, userId }: { name: string; userId: string }) => {
    const lowercaseName = name.toLowerCase();
    supabase
      .from("profile")
      .update({ name: lowercaseName })
      .eq("user_id", userId)
      .then(({ error }) => {
        if (error) {
          Bugsnag.notify(
            new Error(`profile name update error: ${error.message}`),
          );
        } else {
          set(profileNameAtom, lowercaseName);
        }
      });
  },
);

observe((get, set) => {
  const userId = get(currentUserIdAtom);

  if (!userId) {
    set(profileNameAtom, null);
    return;
  }

  supabase
    .from("profile")
    .select("name")
    .eq("user_id", userId)
    .single()
    .then(({ data, error }) => {
      if (error) {
        Bugsnag.notify(new Error(`profile name fetch error: ${error.message}`));
        return;
      }
      set(profileNameAtom, data?.name ?? null);
    });
});
